import { render, staticRenderFns } from "./searchModule.vue?vue&type=template&id=8744d962&scoped=true&"
import script from "./searchModule.vue?vue&type=script&lang=js&"
export * from "./searchModule.vue?vue&type=script&lang=js&"
import style0 from "./searchModule.vue?vue&type=style&index=0&id=8744d962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8744d962",
  null
  
)

export default component.exports